import React, { useEffect } from 'react';
import DefaultLayout from './DefaultLayout';
import { useDispatch, useSelector } from 'react-redux';
import { getUserBookings } from '../redux/actions/bookingActions';
import { Col, Row } from 'antd';
import dayjs from 'dayjs';
import Spinner from '../components/Spinner';

function UserBookings() {
  const dispatch = useDispatch();
  const { bookings } = useSelector(state => state.bookingsReducer);
  const { loading } = useSelector((state) => state.alertsReducer);
  const user = JSON.parse(localStorage.getItem("user"));

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user'));
    if (user) {
      console.log("👤 Current user in localStorage:", user);
      dispatch(getUserBookings(user.user._id));
    }
  }, [dispatch]);

  if (loading) return <Spinner />;
  if (!bookings.length) return <p>No bookings available</p>;

  return (
    <DefaultLayout>
      <h3 className='text-center mt-2'>My Bookings</h3>
      <Row justify='center' gutter={16}>
        <Col lg={15} sm={24}>
          {bookings.map(booking => {
            if (!booking.car) return null; // skip if car is missing

            return (
              <Row key={booking._id} className='bs1 mt-3 text-left'>
                <Col lg={6} sm={24}>
                  <p><b>{booking.car.make}</b></p>
                  <p>Pickup: <b>{booking.pickupLocation}</b></p>
                  <p>Dropoff: <b>{booking.dropoffLocation}</b></p>
                  <p>Total amount: <b>${booking.totalAmount}</b></p>
                </Col>
                <Col lg={12} sm={24}>
                  <p>Transaction ID: <b>{booking.transactionId}</b></p>
                  <p>From: <b>{dayjs(booking.bookedTimeSlots[0]?.from).format('MMM DD, YYYY h:mm A')}</b></p>
                  <p>To: <b>{dayjs(booking.bookedTimeSlots[0]?.to).format('MMM DD, YYYY h:mm A')}</b></p>
                  <p><strong>Estimated time:</strong> {booking.estimatedTime}</p>
                  <p>Distance: <b>{booking.distanceInMiles} miles</b></p>
                  <p>Date of booking: <b>{dayjs(booking.createdAt).format('MMM DD YYYY')}</b></p>
                </Col>
                <Col lg={6} sm={24}>
                  <img src={booking.car.image} style={{ borderRadius: 5 }} height='140' className='p-2'  alt='image'/>
                </Col>
              </Row>
            );
          })}
        </Col>
      </Row>
    </DefaultLayout>
  );
}

export default UserBookings;
